import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function ex_subnodeVisibility(vis: boolean) {
  LwAPI?.subnodeVisibility(vis).then(function (_result) {});
}

// Bind functions to buttons
document
  .getElementById("hide")
  ?.addEventListener("click", async () => {
    await apiReady;
    ex_subnodeVisibility(true);
  });
document
  .getElementById("show")
  ?.addEventListener("click", async () => {
    await apiReady;
    ex_subnodeVisibility(false);
  });
